import { Space, Tooltip } from 'antd'
import { CopyPasteIconProps } from './types'
import { CheckOutlined, CopyTwoTone } from '@ant-design/icons'
import { useState } from 'react'
import { simpleSuccessNotification } from 'hooks/notificationHandler'

/**
 * should only be used if you can't reasonably use Ant Design's Typography
 * component and its built in copy/paste functionality
 */
const CopyPasteIcon: React.FC<CopyPasteIconProps> = ({
  children,
  copyable,
  notify,
  tooltip,
}) => {
  const sendNotification = notify ?? true
  const [copied, setCopied] = useState(false)
  if (!copyable) return <>{children}</>
  return (
    <Space size="small">
      {children}
      {copied ? (
        <CheckOutlined style={{ color: '#52c41a' }} />
      ) : (
        <Tooltip title={tooltip}>
          <CopyTwoTone
            onClick={async () => {
              const copied =
                typeof copyable === 'string' ? copyable : await copyable()
              if (!copied) return
              setCopied(true)
              await navigator.clipboard.writeText(copied)
              if (typeof sendNotification === 'boolean') {
                if (sendNotification)
                  simpleSuccessNotification(`${copied} copied to clipboard!`)
              } else simpleSuccessNotification(sendNotification.message)
              setTimeout(() => setCopied(false), 3000)
            }}
          />
        </Tooltip>
      )}
    </Space>
  )
}

export default CopyPasteIcon
